import { createStyles, makeStyles } from '@mui/styles';
import { ITheme } from 'theme/types';

const useStyles = makeStyles((theme: ITheme) => ({
  input: {
    marginBottom: theme.spacing(2),
  },
}));

export default useStyles;
